module.exports = __webpack_public_path__ + "img/141.13e7897f.jpg";